/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import uuid from 'react-uuid';
import DirectOrderSummary from '../DirectOrderSummary';
import { distributorService } from '../../../../service/distributor.service';
import ProductCard from '../ProductCard';
import CartDetailsSkeleton from '../ProductsListing/CartDetailsSkeleton';
import EmptyPage from '../../../../Components/EmptyPage';

function Cart() {
    const { orderId, distributorId } = useParams();
    const [ThreelPl, setThreelPl] = useState([]);
    const [ThreePlPopup, setThreePlPopup] = useState('');
    const [addressDropdown, setaddressDropdown] = useState({});
    const [distributorDetails, setdistributorDetails] = useState({});
    const [OrderDetails, setOrderDetails] = useState({});
    const [UserRole, setUserRole] = useState('');
    const [loading, setloading] = useState(true);
    const [GroupCategoryValue, setGroupCategoryValue] = useState('');
    const [ItemLevel3pl, setItemLevel3pl] = useState({});

    const get3pl = useCallback(
        async () => {
            if (ThreePlPopup === '') {
                const response = await distributorService.getNewthreepl();
                if (!response.error) {
                    setThreelPl(response.data.data);
                    // setYesUpdate(!YesUpdate);
                }
            }
        },
        [],
    );

    const handleshipbilladdress = (addressList) => {
        // let addressList = await distributorService.Getaddress()
        const shipping_address = [];
        const billing_address = [];
        if (addressList.length > 0) {
            addressList.map((item, i) => {
                const unique_id = uuid();

                if (item.SITE_USE_CODE === 'BILL_TO') {
                    item.unique_id = `${unique_id}-${i}`;
                    billing_address.push(item);
                } else {
                    item.unique_id = `${unique_id}-${i}`;
                    shipping_address.push(item);
                }
            });
        }
        setaddressDropdown({
            shipping_address,
            billing_address,
        });
        return {
            shipping_address, billing_address,
        };
    };

    const getAddresList = (id) => {
        distributorService.getDistributorDetail(id).then((res) => {
            if (!res.error && res.data.success_status) {
                setdistributorDetails(res?.data?.data);
                distributorService.getDistributorAddress(res?.data?.data.CUST_ACCOUNT_ID).then((res1) => {
                    if (!res1.error && res1.data.success_status) {
                        handleshipbilladdress(res1?.data?.data);
                    }
                });
            }
        });
    };
    const handleFetchOrder = useCallback(
        async () => {
            const details = await distributorService.ViewOrderDetails(orderId, distributorId);
            if (!details.error && details.data.success_status) {
                getAddresList(details?.data?.data?.distributor_id);
                details.data.data.cart_items = [];
                Object.entries(details.data.data?.items).map(([key, items]) => {
                    details.data.data.cart_items = details.data.data.cart_items.concat(items);
                });
                setOrderDetails(details.data.data);
                get3pl();
                const current = JSON.parse(localStorage.getItem('user')).profile.roles;
                setUserRole(current);
                setloading(false);
                setTimeout(() => {
                    window.scrollTo(0, 0);
                }, 2000);
            } else {
                // handleErrorMessage(details?.data.message);
                setloading(false);
            }
        },
        [],
    );
    const handleFetch = useCallback(
        async () => {
            const details = await distributorService.ViewOrderDetails(orderId, distributorId);
            if (!details.error && details.data.success_status) {
                getAddresList(details?.data?.data?.distributor_id);
                details.data.data.cart_items = [];
                Object.entries(details.data.data?.items).map(([key, items]) => {
                    details.data.data.cart_items = details.data.data.cart_items.concat(items);
                });
                setOrderDetails(details.data.data);
                setloading(false);
            } else {
                // handleErrorMessage(details?.data.message);
                setloading(false);
            }
        },
        [],
    );

    const handleThreepl = async (threepl) => {
        const { items, instruction } = OrderDetails;
        const category = Object.keys(items).length > 0 ? Object.keys(items)[0] : instruction;
        const threeplindex = ThreelPl.findIndex((p) => p.DESCRIPTION === threepl);
        items[category].map((item, index) => {
            items[category][index]['3pl'] = ThreelPl[threeplindex];
        });
        const res = await distributorService.OrderStatusUpdate({ items }, OrderDetails.distributor_id, OrderDetails.order_number);
        if (!res.error && res.data.success_status) {
            handleFetch();
        } else {
            // console.log(res?.message?.response?.data?.message);
        }
    };

    useEffect(() => {
        handleFetchOrder();
    }, []);

    return (
        <div className="flex w-full">
            {!loading
                ? (
                    <>
                        <div className="main-screen px-4 w-[70%]  pt-2 mb-7">

                            <div className="w-full">
                                <div className="flex items-center mt-[25px] lg:w-[50%] w-full">
                                    <Link to={`/manage-orders/direct-order/${distributorId}/${orderId}/edit`}>
                                        <img src="/images/arrow-back-fill.svg" alt="icon" />
                                    </Link>
                                    <p className="flex flex-col ml-6">
                                        <span className="text-sm26 font-semibold text-[#090406]">
                                            Cart (
                                            { OrderDetails?.cart_items?.length }
                                            )
                                        </span>
                                    </p>
                                </div>
                                <div>
                                    {OrderDetails?.items && Object.entries(OrderDetails?.items).map(([key, items]) => (
                                        items.length > 0 && (
                                            <>
                                                <div className="flex justify-end w-full">
                                                    <p className="text-[#777777] pt-1 pr-2 text-sm43">3PL Location</p>
                                                    <div className="dropdown relative">
                                                        <select
                                                            onChange={(e) => handleThreepl(e.target.value)}
                                                            className="h-7 w-full rounded-lg outline-0 border bg-[#F5F5FA] border-[#B1B4B7] bg-[#FFFFFF] font-semi-bold text-base text-[#555259] px-3.5"
                                                        >
                                                            {ThreelPl && ThreelPl.map((item, threeindex) => (
                                                                <option key={threeindex} value={item.DESCRIPTION} selected={item.DESCRIPTION === items[0]['3pl'].DESCRIPTION}>{item.DESCRIPTION}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="flex lg:flex-row flex-col sm:pt-[38px] pt-7">
                                                    <div className=" w-full">
                                                        {items.map((prod, i) => (
                                                            <div className="w-full">
                                                                <ProductCard
                                                                    prod={prod}
                                                                    OrderDetails={OrderDetails}
                                                                    setOrderDetails={setOrderDetails}
                                                                    addressDropdown={addressDropdown}
                                                                    setThreePlPopup={setThreePlPopup}
                                                                    GroupCategory={GroupCategoryValue}
                                                                    setGroupCategoryValue={setGroupCategoryValue}
                                                                    groupIdx={key}
                                                                    UserRole={UserRole}
                                                                    setItemLevel3pl={setItemLevel3pl}
                                                                    handleFetch={handleFetch}
                                                                    itemIndex={i}
                                                                    ThreelPl={ThreelPl}
                                                                />
                                                            </div>
                                                        ))}

                                                    </div>
                                                </div>
                                            </>
                                        )
                                    ))}
                                    {OrderDetails?.cart_items?.length === 0 && <EmptyPage tag=" no products" STOCK_VISIBILITY /> }
                                </div>

                            </div>
                        </div>
                        {OrderDetails?.cart_items?.length > 0 && <DirectOrderSummary OrderDetails={OrderDetails} /> }
                    </>
                ) : <CartDetailsSkeleton />}
        </div>
    );
}

export default Cart;
